import { z } from "zod";

// Lives in shared/ (not api/cede-arena) so hub.ts can read it without pulling in
// the cede-arena barrel, which cycles back through trade-to-earn → hub.

/**
 * Opponent snapshot on a live proposal. Identity is withheld until both sides
 * confirm, so a user can't decline to dodge a specific opponent. `readyConfirmedAt`
 * is exposed either way — it drives the two-checkmark state and leaks nothing,
 * since a bot's confirm is already jittered a few seconds like a human's.
 *
 * Never reveals whether the opponent is a bot.
 */
export const ArenaMatchOpponentDtoSchema = z.discriminatedUnion("identityRevealed", [
  z.object({
    identityRevealed: z.literal(false),
    readyConfirmedAt: z.string().nullable(),
  }),
  z.object({
    identityRevealed: z.literal(true),
    displayName: z.string(),
    readyConfirmedAt: z.string().nullable(),
  }),
]);
export type ArenaMatchOpponentDto = z.infer<typeof ArenaMatchOpponentDtoSchema>;
